export enum ESigningStep {
  Biometric = 'biometric',
  Qna = 'qna',
  Sms = 'sms',
  Eid = 'eid',
  Click = 'click',
}
